import ReservationBillingModal from './ReservationBillingModal'

export default ReservationBillingModal
